export const HOUSE_FLOOR_MIN = 1;
export const HOUSE_FLOOR_MAX = 170;
export const FLAT_PAY_DAY_MIN = 1;
export const FLAT_PAY_DAY_MAX = 28;
export const DASHBOARD_YEAR_MIN = 2000;
export const APP_DEVELOPED_BY = 'htally.com';
export const APP_OTP_EXPIRY_SECONDS = 4 * 60;
export const EMPLOYEE_CREATE_LIMIT = 10;

export interface YearDropdownOption {
  [key: string]: unknown;
  value: number;
  label: string;
}

export function buildYearDropdownOptions(minYear = DASHBOARD_YEAR_MIN, maxYear = new Date().getFullYear()): YearDropdownOption[] {
  const safeMin = Number.isFinite(minYear) ? Number(minYear) : DASHBOARD_YEAR_MIN;
  const safeMax = Number.isFinite(maxYear) ? Number(maxYear) : new Date().getFullYear();
  const options: YearDropdownOption[] = [];

  for (let year = safeMax; year >= safeMin; year -= 1) {
    options.push({ value: year, label: `${year}` });
  }

  return options;
}

export enum PaymentMethodEnum {
  CASH = 1,
  BANK = 2,
  CHEQUE = 3,
  MOBILE_BANKING = 4,
  ADJUST_FROM_ADVANCE = 5,
  OTHER = 6
}

export enum FeatureTypeEnum {
  RENTER_IMAGE = 1,
  FLAT_RENTER_AGREEMENT = 2,
  ORGANIZATION_LOGO_OR_EMPLOYEE_IMAGE = 3
}

export const ATTACHMENT_ALLOWED_EXTENSIONS = ['.jpg', '.jpeg', '.png', '.pdf'] as const;
export const ATTACHMENT_MAX_FILE_SIZE_BYTES = 2 * 1024 * 1024;

export const ATTACHMENT_IMAGE_EXTENSIONS = ['.jpg', '.jpeg', '.png'] as const;

export const ATTACHMENT_MAX_FILE_COUNT_BY_FEATURE: Record<FeatureTypeEnum, number> = {
  [FeatureTypeEnum.RENTER_IMAGE]: 1,
  [FeatureTypeEnum.FLAT_RENTER_AGREEMENT]: 3,
  [FeatureTypeEnum.ORGANIZATION_LOGO_OR_EMPLOYEE_IMAGE]: 1
};

export const ATTACHMENT_ALLOWED_EXTENSIONS_BY_FEATURE: Record<FeatureTypeEnum, readonly string[]> = {
  [FeatureTypeEnum.RENTER_IMAGE]: ATTACHMENT_IMAGE_EXTENSIONS,
  [FeatureTypeEnum.FLAT_RENTER_AGREEMENT]: ATTACHMENT_ALLOWED_EXTENSIONS,
  [FeatureTypeEnum.ORGANIZATION_LOGO_OR_EMPLOYEE_IMAGE]: ATTACHMENT_IMAGE_EXTENSIONS
};
